import React from "react";
import { Layout, Menu, Typography } from "antd";
import { withRouter } from "react-router";

import "./Layouts.css";

const { Header, Footer, Content } = Layout;

const GuestLayout = (props) => (
  <Layout className="layout" style={{ minHeight: "100vh" }}>
    <Content className={props.contentClass || "Content"}>
      {props.children}
    </Content>
  </Layout>
);

export default withRouter(GuestLayout);
